import React, { createContext, useContext, useRef, useState } from 'react';
import { jwtDecode } from 'jwt-decode';
import { setAuthToken } from './auth.ts';

export const AppContext = createContext();

export const AppContextProvider = ({ children }) => {
    const [tokenData, setTokenData] = useState(null);

    const updateToken = (token) => {
        if (!token) return;
        localStorage.setItem('token', token);
        setAuthToken(token);
        setTokenData(jwtDecode(token));
    };

    const removeToken = () => {
        localStorage.removeItem('token');
        setAuthToken(null);
        setTokenData(null);
    }

    const storageToken = localStorage.getItem('token');
    if (!tokenData && storageToken) {
        updateToken(storageToken);
    }

    const refetchUnauthorizedUserCountRef = useRef(() => {});

    const context = {
        tokenData,
        updateToken,
        removeToken,
        refetchUnauthorizedUserCountRef,
        rtl: !localStorage.getItem('lang') ? true : localStorage.getItem('lang') === 'he',
    };

    return (
    <AppContext.Provider value={context}>
        {children}
    </AppContext.Provider>
    );
};

export const useAppContext = () => useContext(AppContext);
